/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-14 11:22:01
 * @LastEditTime: 2019-09-20 11:46:22
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import vuex from 'vuex'
import user from './modules/user'
import base from './modules/base'
import clinical from './modules/clinical'

Vue.use(vuex)

export default new vuex.Store({
  state: {
    system: '',
    isWeChat: false,
    platform:'WeChat',
    placeSource: null, // 页面来源 [0-开机动画,1-首页弹窗,2-Banner,3-feed流,4-搜索词广告,5-PUSH,6-短信,7-站内信,8-微信群,9-朋友圈，10-专栏阅读]
    type: 1, // 默认为1 ，可以抽奖，0则是不可以抽奖
    userNewApp: true, // 默认使用APP新的交互
    yszActivityStatus: null, // 活动状态【1进行中 2 结束】
    isToIosNative: false, // 是否和ios交互取APP的用户信息 false是没有交互
    notNeedLogin: 0, // 是否需要登陆， 0 不需要 1 需要
    isApp: 0, // 是否APP，0不是 1是
    canSearchFormula: true, // 是否可以搜索医学公式[以解决ios搜索按钮变成确认按钮不可搜索问题，true-搜索框获取焦点，false-点击其他位置防触发搜索事件]
    feedbackStatus: false // 意见反馈图标展示   false 是小图标 true是大图标
  },
  getters: {
    system (state) {
      return state.system
    },
    isWeChat (state) {
      return state.isWeChat
    },
    platform (state) {
      return state.platform
    },
    placeSource (state) {
      return state.placeSource
    },
    type (state) {
      return state.type
    },
    userNewApp (state) {
      return state.userNewApp
    },
    yszActivityStatus (state) {
      return state.yszActivityStatus
    },
    isToIosNative (state) {
      return state.isToIosNative
    },
    notNeedLogin (state) {
      return state.notNeedLogin
    },
    isApp (state) {
      return state.isApp
    },
    searchFormulaState (state) {
      return state.canSearchFormula
    },
    feedbackStatus (state) {
      return state.feedbackStatus
    }
  },
  modules: {
    user, base, clinical
  },
  mutations: {
    useNewAppIt (state, userNewApp) {
      state.userNewApp = userNewApp
    },
    canSearchFormula (state, canSearchFormula) {
      state.canSearchFormula = canSearchFormula
    },
    feedbackStatusCommit (state, feedbackStatus) {
      state.feedbackStatus = feedbackStatus
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js